import React, { useEffect } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

import PublicShell from '../components/PublicShell';

import { useTippspielBranding } from '../hooks/useTippspielBranding';



const features = [

  {

    icon: '⚽',

    title: 'Vor dem Anpfiff tippen',

    text: 'Gib deine Ergebnis-Prognosen ab, bevor die Deadline schließt – so bleibt jedes Spiel spannend bis zur letzten Minute.',

  },

  {

    icon: '🏆',

    title: 'Rangliste & Rivalität',

    text: 'Miss dich mit anderen Fans in der Live-Rangliste. Wer trifft die meisten Ergebnisse exakt?',

  },

  {

    icon: '📊',

    title: 'Deine Statistik',

    text: 'Trefferquote, exakte Tipps, Punkte pro Spieltag – du siehst genau, wie gut dein Fußball-Bauchgefühl ist.',

  },

  {

    icon: '🔒',

    title: 'Nur für Mitspieler',

    text: 'Tipps sind privat bis zur Deadline. Danach siehst du, wie andere getippt haben – fair und transparent.',

  },

];



const steps = [

  { n: '1', title: 'Kostenlos registrieren', text: 'Benutzername, E-Mail, Passwort – fertig in einer Minute.' },

  { n: '2', title: 'Spiele tippen', text: 'Offene Partien der Saison auswählen und dein Ergebnis eingeben.' },

  { n: '3', title: 'Punkte sammeln', text: 'Exakt, Tendenz oder Tordifferenz – je nach Treffer gibt es Punkte.' },

  { n: '4', title: 'Tabellenführer werden', text: 'Verfolge deinen Platz in der Rangliste und verbessere deine Quote.' },

];



const LandingPage = () => {

  const { isAuthenticated, loading } = useAuth();

  const { seasonLabel } = useTippspielBranding();

  const navigate = useNavigate();



  useEffect(() => {

    if (!loading && isAuthenticated) {

      navigate('/uebersicht', { replace: true });

    }

  }, [isAuthenticated, loading, navigate]);



  if (loading) {

    return (

      <div className="page-bg flex items-center justify-center min-h-screen">

        <span className="loading loading-spinner loading-lg text-primary" />

      </div>

    );

  }



  return (

    <PublicShell>

      <section className="text-center mb-16 md:mb-24 pt-4 md:pt-10">

        <span className="t12-badge">Saison {seasonLabel}</span>

        <h1 className="page-headline mb-6 max-w-3xl mx-auto">

          Tippe. Vergleiche.

          <br />

          <strong>Gewinne die Saison.</strong>

        </h1>

        <p className="text-lg md:text-xl text-white/55 max-w-2xl mx-auto mb-10 leading-relaxed">

          Du willst wissen, ob du die Spiele besser einschätzen kannst als deine Freunde?

          {' '}

          <strong className="text-white/90 font-semibold">Melde dich an</strong>

          {' '}

          – nur registrierte Spieler können Tipps abgeben und in der Rangliste erscheinen.

        </p>

        <div className="flex flex-wrap justify-center gap-4">

          <Link to="/register" className="btn-wacker px-8">

            Jetzt mitmachen

          </Link>

          <Link to="/login" className="btn-wacker-outline px-8">

            Anmelden

          </Link>

        </div>

        <p className="text-xs uppercase tracking-[0.12em] text-white/35 mt-8">

          Keine Kosten · Kein Download · Direkt im Browser

        </p>

      </section>



      <section className="mb-16 md:mb-24">

        <h2 className="section-title text-center mb-3">Warum anmelden?</h2>

        <p className="text-center text-white/50 max-w-xl mx-auto mb-10">

          Ohne Konto kannst du die Startseite sehen – zum Tippen und für die Rangliste brauchst du ein Profil.

        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

          {features.map((f) => (

            <div key={f.title} className="feature-card">

              <div className="feature-card-icon">{f.icon}</div>

              <h3 className="text-xl font-bold text-white mb-2">{f.title}</h3>

              <p className="text-white/55 leading-relaxed">{f.text}</p>

            </div>

          ))}

        </div>

      </section>



      <section className="mb-16 md:mb-24">

        <h2 className="section-title mb-8 px-2">So sieht&apos;s aus</h2>

        <div className="max-w-lg mx-auto glass-card overflow-hidden">

          <div className="p-5 md:p-6 border-b border-white/10">

            <div className="text-xs font-bold uppercase tracking-[0.14em] text-primary mb-1">Beispiel</div>

            <div className="text-white font-bold">Regionalliga · Spieltag 12</div>

          </div>

          <div className="p-5 md:p-6">

            <div className="match-board mb-4">

              <div className="match-board-side">

                <div className="w-14 h-14 rounded-xl bg-white/5 p-2 flex items-center justify-center">

                  <img

                    src="https://fc-wacker-innsbruck.at/wp-content/uploads/2023/05/FCW_Wappen_NEU.png"

                    alt=""

                    className="max-h-full max-w-full object-contain"

                  />

                </div>

                <div className="match-board-team">FC Wacker Innsbruck</div>

                <div className="score-badge w-14 text-center">2</div>

              </div>

              <div className="match-board-center">

                <span className="match-board-colon">:</span>

              </div>

              <div className="match-board-side">

                <div className="w-14 h-14 rounded-xl bg-white/5 p-2 flex items-center justify-center">

                  <img

                    src="https://vereine.oefb.at/Content/images/svg/logo-placeholder.svg"

                    alt=""

                    className="max-h-full max-w-full object-contain opacity-70"

                  />

                </div>

                <div className="match-board-team">Gegner</div>

                <div className="score-badge w-14 text-center">1</div>

              </div>

            </div>

            <p className="text-center text-sm text-white/45">

              Deadline: 15 Min. vor Anpfiff

            </p>

          </div>

        </div>

      </section>



      <section className="mb-16 md:mb-24">

        <h2 className="section-title text-center mb-10">In 4 Schritten dabei</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

          {steps.map((s) => (

            <div key={s.n} className="stat-card text-center">

              <div className="w-10 h-10 mx-auto mb-4 rounded-full bg-primary/20 border border-primary/35 flex items-center justify-center font-black text-primary-light">

                {s.n}

              </div>

              <h3 className="font-bold text-white mb-2">{s.title}</h3>

              <p className="text-sm text-white/55">{s.text}</p>

            </div>

          ))}

        </div>

      </section>



      <section className="glass-card p-8 md:p-12 text-center">

        <span className="t12-badge mb-4">Los geht&apos;s</span>

        <h2 className="text-2xl md:text-3xl font-light text-white mb-4 tracking-tight">

          Bereit für die <strong className="font-bold text-primary">nächste Runde</strong>?

        </h2>

        <p className="text-white/55 max-w-lg mx-auto mb-8">

          Registriere dich jetzt und verpasse kein Spiel mehr.

        </p>

        <Link to="/register" className="btn-wacker px-10">

          Konto erstellen

        </Link>

      </section>

    </PublicShell>

  );

};



export default LandingPage;


